import { enableProdMode, ErrorHandler, importProvidersFrom } from '@angular/core';

import { FormsModule } from '@angular/forms';
import { bootstrapApplication, BrowserModule } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { EnvironmentModule } from '@pinnakl/core/environment';
import { PinnaklErrorHandler } from '@pinnakl/core/errors-processing';
import {
  AG_GRID_KEY,
  AG_GRID_KEY_TOKEN,
  HTTP_SERVER_URL,
  LOCATION
} from '@pinnakl/shared/constants';
import { PinnaklPrimePreset, UiToastMessageService } from '@pinnakl/shared/ui/prime';
import { PageSubscriptionsHandler } from '@pinnakl/shared/util-helpers';
import { PinnaklUIToastMessage } from '@pinnakl/shared/util-providers';
import { MessageService } from 'primeng/api';
import { providePrimeNG } from 'primeng/config';
import { ToastModule } from 'primeng/toast';
import { AppRoutingModule } from './app/app-routing.module';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: PinnaklPrimePreset,
        options: {
          darkModeSelector: false,
          cssLayer: {
            name: 'primeng',
            order: 'primeng'
          }
        }
      }
    }),
    importProvidersFrom(
      BrowserModule,
      EnvironmentModule.forRoot({ config: environment }),
      AppRoutingModule,
      FormsModule,
      ToastModule
    ),
    MessageService,
    {
      provide: PinnaklUIToastMessage,
      useClass: UiToastMessageService
    },
    {
      provide: HTTP_SERVER_URL,
      useValue: environment.coreApiServerUrl
    },
    {
      provide: LOCATION,
      useValue: location
    },
    {
      provide: ErrorHandler,
      useClass: PinnaklErrorHandler
    },
    {
      provide: AG_GRID_KEY_TOKEN,
      useValue: AG_GRID_KEY
    },
    PageSubscriptionsHandler,
    provideAnimations()
  ]
}).catch(err => console.error(err));
